import { commonActions } from  '../../actions/commonActions';
import { dashboardSetItem, dashboardGetItem,dashboardGetNote } from '../../actions/dashboardActions';
import { connect } from 'react-redux';
import {alertConstants, commonConstants} from '../../constants';
import DashboardComponent from '../../components/dashboard/Dashboard'
import { logout } from '../../actions/appAction';
import {API_FETCH} from "../../services/FetchService";

const mapDispatchToProps = dispatch => ({
  onPageLoad: view => 
      dispatch(commonActions.pagePreLoaded(view)),
  onAuthFailed: () =>{
    dispatch(logout());
  },
  onRedirect: (link) => {
    dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: link})
  },
  getItem: () => {
    dispatch(getItem());
  },
  getNote: () => {
    dispatch(getNote());
  },
  /* ------------ -------------- ------------*/
  /* ------------ ON SUbmit Form ------------*/
  /* ------------ -------------- ------------*/
  handleSubmit: (value)=>{
    dispatch(edit(value));
  },
});

const mapStateToProps = state => {
  return {
    common: state.common,
    initialValues: state.dashboard.getItem,
    getNoteValues: state.dashboard.getNote
  }
};

/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const edit = (value,mode) => {

  return (dispatch, getState) => {

    var formData = {
      'note' : value
    };

    dispatch({type: commonConstants.FORM_REQUEST});
    API_FETCH.put('user/note', formData).then(res => {
      dispatch(dashboardSetItem(res.data));
      if(res.status === 200) {
        dispatch({type: commonConstants.FORM_SUCCESS});
        dispatch({
          type: alertConstants.SUCCESS,
          message: 'عملیات شما با موفقیت انجام شد'
        })
      }else {
        dispatch({type: commonConstants.FORM_FAILURE});
        dispatch({
          type: alertConstants.ERROR,
          message: 'خطا در ایجاد'
        })
      }
    }).catch(error => {
      dispatch({type: commonConstants.FORM_FAILURE});
      dispatch({
        type: alertConstants.ERROR,
        message: 'خطای سرور'
      })
    });

  }
}

const getNote = () => {

  return (dispatch, getState) => {
    API_FETCH.post('user/note').then(dashboardInfo => {
      dispatch(dashboardGetNote(dashboardInfo.data));
    }).catch(error => {
      console.log(error);
    });

  }
}

const getItem = () => {
  return (dispatch, getState) => {
    API_FETCH.get('order/stats').then(dashboardInfo => {
      dispatch(dashboardGetItem(dashboardInfo.data));
    }).catch(error => {
      console.log(error);
    });
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);